// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.hml.ts` / `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { EnvironmentConfig } from './environment.model';

export const environment: EnvironmentConfig = {
  production: false,
  envName: 'dev',
  
  
  // Não existe um ambiente "dev" real conhecido para o Affix. Os domínios
  // abaixo foram extraídos diretamente do bundle JS de produção/hml real do
  // portal (main.df0389c59a0be610.js, portal-hml.affixtech.com.br,
  // 21/08/2026) — não são mais inferência por convenção de nome, são os
  // valores reais usados pelo app original em homologação. `npm start`
  // aponta pra eles por padrão até haver um domínio de dev de verdade.
  recaptchaSiteKey: '6Ld2inMjAAAAANk2QOBCT9ZT4CtwokrIQayXhldN', // site key real (HML), extraída do bundle
  skipTwoFactorInDev: true,
  // Temporário: a API de títulos pendentes ainda retorna 501.
  
  apiUrls: {
        // Migrado para a API v1 do Portal Multiempresas (mesmo Swagger de comunicados).
    // A base termina em /api — o "/v1" vem do endpoints.ts.
    infraestrutura: 'https://portal-multiempresas-dev-cnh8fzgnhzfgfrdt.brazilsouth-01.azurewebsites.net/api',
    gestaoMedica: 'https://api-gestao-medica.hml.affixtech.com.br/api',
    preCadastro: 'https://api-precadastro.hml.affixtech.com.br/api',
    
    // Migrado para a API nova do Portal Multiempresas (mesmo Swagger do login).
    // A base termina em /api — o "/v1" vem do endpoints.ts.
    comunicados: 'https://portal-multiempresas-dev-cnh8fzgnhzfgfrdt.brazilsouth-01.azurewebsites.net/api',

    
    atendimento: 'https://portal-multiempresas-dev-cnh8fzgnhzfgfrdt.brazilsouth-01.azurewebsites.net/api',
    // TODO: não encontrado no bundle principal — mantido como melhor palpite.


    controleUsuarios: 'https://api-infraestrutura.hml.affixtech.com.br/api',
    // TODO: não encontrado no bundle principal — mantido como melhor palpite.
    titulosPendentes: 'https://portal-multiempresas-dev-cnh8fzgnhzfgfrdt.brazilsouth-01.azurewebsites.net/api',
    //Temporário: a API de títulos pendentes ainda retorna 501.
    

    // "Extratos Corretores" = extrato de comissão — mapeado para o serviço
    // de Comissão confirmado no bundle (UrlApiComissao), não confirmado 1:1
    // com a tela ainda.
    extratos: 'https://api-comissao.hml.affixtech.com.br/api',
    // TODO: não encontrado no bundle principal (pode estar em um chunk lazy
    // não carregado durante a varredura) — mantido como melhor palpite.
    propostaMigracao: 'https://api-precadastro.hml.affixtech.com.br/api',
    // TODO: não encontrado no bundle principal — mantido como melhor palpite.
    iaRetencao: 'https://api-salvavidas.hml.affixtech.com.br/api',
    financeiro: 'https://api-financeiro.hml.affixtech.com.br/api/v1',
    // TODO: não encontrado no bundle principal — mantido como melhor palpite.
    modeloProposta: 'https://api-precadastro.hml.affixtech.com.br/api',
    // TODO: não encontrado no bundle principal — mantido como melhor palpite.
    estudosMigracao: 'https://api-precadastro.hml.affixtech.com.br/api',
    vendaOnline: 'https://api-venda-online.hml.affixtech.com.br/api/v1',
    // Confirmados no bundle, ainda sem módulo de tela associado com certeza.
    cliente: 'https://api-cliente.hml.affixtech.com.br/api/v1',
    salvaVidas: 'https://api-salvavidas.hml.affixtech.com.br/api',
  },
};
